import { motion } from "framer-motion";
import { fadeUp } from "./animations";

export default function TechnologyIntro() {
  return (
    <section
      id="services"
      className="
        bg-[#f6f6f6]
        py-20
        sm:py-24
        lg:py-28
      "
    >
      <div
        className="
          mx-auto
          max-w-7xl
          px-5
          sm:px-8
          lg:px-10
        "
      >
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
          }}
          className="max-w-4xl"
        >
          <SectionLabel>What We Build</SectionLabel>

          <h2
            className="
              merriweather
              mt-5
              text-3xl
              font-black
              tracking-[-0.04em]
              sm:text-4xl
              lg:text-[54px]
              lg:leading-[1.08]
            "
          >
            Different goals.
            <span className="block text-neutral-400">
              One technology partner.
            </span>
          </h2>

          <p
            className="
              mt-7
              max-w-3xl
              text-[16px]
              leading-8
              text-neutral-600
            "
          >
            Some businesses need better software. Some need more customers.
            Others need a digital presence people remember. We start with the
            problem and build the right solution around it — not around a
            template.
          </p>
        </motion.div>
      </div>
    </section>
  );
}

function SectionLabel({ children, dark = false }) {
  return (
    <div
      className={`
        flex
        items-center
        gap-3
        text-[10px]
        font-bold
        uppercase
        tracking-[0.2em]
        ${dark ? "text-[#55aef3]" : "text-[#3899e4]"}
      `}
    >
      <span className="h-[1px] w-8 bg-[#55aef3]" />

      {children}
    </div>
  );
}
